import React from "react";

import { Box, styled, Typography } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import ExerciseFieldIcon from "./ExerciseFieldIcon";
import Spacer from "../../../../../../components/layout/Spacer";

interface Props {
  label: string;
  value: any;
  unit?: string;
}

const Root = styled("div")({
  display: "flex",
  alignItems: "center",
});

const IconContainer = withStyles(Box, {
  root: {
    alignItems: "center",
    backgroundColor: "#F7F9FB",
    borderRadius: "50%",
    color: colors.gray,
    display: "flex",
    height: 40,
    justifyContent: "center",
    marginRight: "8px",
    width: 40,
  },
});

const ExerciseFieldValueText = withStyles(Typography, {
  root: {
    color: "#363E45",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.125,
  },
});

const ExerciseFieldDescText = withStyles(Typography, {
  root: {
    color: "#4C515A",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.125,
  },
});

const ExerciseField: React.FC<Props> = ({ label, value, unit }) => {
  return (
    <Root>
      <IconContainer>
        <ExerciseFieldIcon label={label} />
      </IconContainer>
      <Box>
        <ExerciseFieldValueText>
          {value} {unit}
        </ExerciseFieldValueText>
        <Spacer y={6} px />
        <ExerciseFieldDescText>{label}</ExerciseFieldDescText>
      </Box>
    </Root>
  );
};

export default ExerciseField;
